import cleanedFilename from '~/util/cleanedFilename';

export default {
  EMPTY_STATE: `${cleanedFilename(__filename)}-empty-state`,
};
